import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const PurchaseSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    
    if (sessionId) {
      // Set a timeout to simulate loading (in a real app, you'd fetch order details)
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1500);
      
      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, [searchParams]);
  
  if (loading) {
    return (
      <div style={{ padding: "1rem", maxWidth: 700, margin: "0 auto" }}>
        <div style={{ 
          padding: "1rem", 
          backgroundColor: "#f5f5f5", 
          borderRadius: "4px",
          textAlign: "center"
        }}>
          <p>Confirming your order...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div style={{ padding: "1rem", maxWidth: 700, margin: "0 auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
        <h1 style={{ fontSize: "1.5rem", margin: 0 }}>Purchase Confirmation</h1>
      </div>
      
      <div style={{ 
        border: "1px solid #ccc", 
        padding: "1rem", 
        marginBottom: "1rem",
        borderRadius: "4px" 
      }}>
        <h2 style={{ fontSize: "1.2rem", marginTop: 0, color: "#4CAF50" }}>Thank You for Your Purchase!</h2>
        <p>Your order has been successfully processed.</p>
      </div>
      
      <div style={{ 
        border: "1px solid #2196F3", 
        padding: "1rem", 
        marginBottom: "1rem",
        borderRadius: "4px",
        backgroundColor: "#e3f2fd"
      }}>
        <h2 style={{ fontSize: "1.2rem", marginTop: 0, color: "#2196F3" }}>Next Steps</h2>
        <p>
          Please check your email for registration instructions to access your purchase. 
          If you don't receive an email within 15 minutes, please check your spam folder.
        </p>
        <p>
          Once you complete your registration, you'll be able to access the MISSING experience
          through your user account.
        </p>
      </div>
      
      <div style={{ 
        border: "1px solid #ccc", 
        padding: "1rem",
        borderRadius: "4px" 
      }}>
        <h2 style={{ fontSize: "1.2rem", marginTop: 0 }}>Need Help?</h2>
        <p>
          If you have any questions or need assistance, please contact our support team
          at <a href="mailtosupport@creativetechnologiesincla.zohodesk.com" style={{ color: "#2196F3", textDecoration: "none" }}>
            support@creativetechnologiesincla.zohodesk.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default PurchaseSuccessPage;